import Sidebar from "@/components/Sidebar";

const Layout = ({ children, title }) => {
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content lg:ml-64">
        <div className="p-6 md:p-8 lg:p-10">
          {title && (
            <h1 
              className="text-2xl md:text-3xl font-bold text-gray-900 mb-6"
              style={{ fontFamily: 'Chivo, sans-serif' }}
            >
              {title}
            </h1>
          )}
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
